import { QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

import { ErrorBoundary } from './error-boundary';

import { CookieConsentProvider } from '@/features/cookie-consent/cookie-consent-context';
import { CompareProvider } from '@/features/engagement/compare-context';
import { WishlistProvider } from '@/features/engagement/wishlist-context';
import { createQueryClient } from '@/lib/query-client';

/** Composes app-wide providers: error boundary, server-state, engagement.
 *  The public site needs no authentication and uses a single light theme. */
export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <CookieConsentProvider>
          <WishlistProvider>
            <CompareProvider>{children}</CompareProvider>
          </WishlistProvider>
        </CookieConsentProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
